import { useQuery } from "react-query";
import { roles } from "../../constants/roles";
import { getUsersByRole } from "../../services/users";

/** Plafond : le cabinet compte quelques médecins, une seule page suffit. */
const DOCTORS_PAGE_SIZE = 200;

export type DoctorOption = { id: number; firstName?: string; lastName?: string };

/**
 * Médecins du cabinet pour les choix d'assignation (ajout en file,
 * réassignation). Une seule clé de cache partagée par tous les écrans de file.
 */
export function useDoctors(enabled = true): DoctorOption[] {
  const { data } = useQuery(
    ["queue-doctors"],
    () => getUsersByRole(roles.ROLE_DOCTOR, "", 0, DOCTORS_PAGE_SIZE),
    { enabled, staleTime: 60000 }
  );
  return (data as any)?.data?.content || [];
}

export default useDoctors;
